/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AwsServiceDownloadFilePresignResponse } from './AwsServiceDownloadFilePresignResponse';

export type AwsServiceDownloadFilePresignResponseApiRespoonse = {
    data?: AwsServiceDownloadFilePresignResponse;
    status?: AwsServiceDownloadFilePresignResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AwsServiceDownloadFilePresignResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

